import urlParse from 'url-parse'
import Token from '@web/common/token'
import md5 from 'locutus/php/strings/md5'
import { analyticsBannerClick, analyticsBannerShow } from '@web/services/Analytics/events'
import { onBeforeUnmount, onMounted, ref } from 'vue'

export default function useBanner ({ banner, position }: { banner: Banner, position: string }) {
  const refBanner = ref<HTMLElement | null>(null)
  const isShown = ref(false)

  /**
   * Получние utm меток для баннера
   *
   * @param { position: string, bannerID: string, query: Record<string, string | undefined> } payload
   * @param {string} payload.position - точное размещение баннера в момент показа
   * @param {string} payload.bannerID - ID баннера
   * @param {Record<string, string | undefined>} payload.query - query
   * @returns {object} Сгенерированные query параметры с utm метками
   */
  function getQuery ({ position, bannerID, query }: { position: string, bannerID: string, query: Record<string, string | undefined> }): Record<string, string> {
    const utmMarks: Record<string, string> = {
      utm_source: query.utm_source || 'lk',
      utm_medium: query.utm_medium || 'banner',
      utm_campaign: query.utm_campaign || position,
      utm_term: query.utm_term || bannerID
    }

    return {
      ...query,
      ...utmMarks,
      token: Token.get(),
      _uah: md5(window.navigator.userAgent)
    }
  }

  function getUrl () {
    const url = banner?.surveyFormUrl || banner?.url
    if (url) {
      const urlInstance = urlParse(url, true)
      const query = getQuery({
        position,
        bannerID: banner.id.toString(),
        query: urlInstance.query
      })
      urlInstance.set('query', query)
      return urlInstance.toString()
    }

    return ''
  }
  function getImage () {
    if (banner?.placements.includes('sidebar')) {
      return banner?.image.small
    }

    return banner?.image.large
  }

  function onBannerShow () {
    if (refBanner.value && banner) {
      const screenVisiblePosition: number = window.scrollY + window.innerHeight
      const centerBanner = refBanner.value.offsetTop + (refBanner.value.offsetHeight / 2)
      if (screenVisiblePosition > centerBanner && !isShown.value) {
        analyticsBannerShow({ banner, position, url: getUrl() })
        isShown.value = true
      }
    }
  }

  function onBannerClick () {
    if (banner) {
      analyticsBannerClick({ banner, position, url: getUrl() })
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', onBannerShow, true)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onBannerShow, true)
  })

  return {
    refBanner,
    isShown,
    url: getUrl(),
    image: getImage(),
    onBannerShow,
    onBannerClick
  }
}
